// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   SessionsPage.responsive.css
   Responsive Stylesheet for Clinical Sessions Timeline & Workspace
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgsessions-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgsessions-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgsessions-hero h1 {
    font-size: clamp(28px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgsessions-hero-panel {
    max-width: 100% !important;
    padding: 20px !important;
  }

  .mgsessions-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 18px 0 !important;
  }

  /* Toolbar */
  .mgsessions-toolbar {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }

  .mgsessions-toolbar-filters {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .mgsessions-toolbar-actions {
    display: flex !important;
    gap: 10px !important;
    width: 100% !important;
    justify-content: flex-end !important;
  }

  .mgsessions-grid,
  .sessions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 14px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgsessions-page {
    padding: 10px 10px 30px !important;
  }

  .mgsessions-hero {
    padding: 16px 14px !important;
    gap: 16px !important;
    border-radius: 16px !important;
  }

  .mgsessions-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgsessions-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgsessions-hero-actions {
    display: flex !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .mgsessions-hero-actions .mgsessions-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  .mgsessions-hero-panel {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgsessions-panel-top strong {
    font-size: 15px !important;
  }

  .mgsessions-mini-chart {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin-top: 10px !important;
  }

  .mgsessions-mini-stat {
    padding: 8px 10px !important;
    border-radius: 10px !important;
  }

  .mgsessions-mini-stat strong {
    font-size: 15px !important;
  }

  /* Stats Grid */
  .mgsessions-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgsessions-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .mgsessions-stat-card strong {
    font-size: 18px !important;
  }

  .mgsessions-stat-card span {
    font-size: 10px !important;
  }

  .mgsessions-stat-card small {
    display: none !important;
  }

  /* Toolbar */
  .mgsessions-toolbar {
    margin: 14px 0 !important;
  }

  .mgsessions-toolbar-filters {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  .mgsessions-filter-input,
  .mgsessions-filter-select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  .mgsessions-toolbar-actions {
    display: flex !important;
    gap: 8px !important;
  }

  .mgsessions-toolbar-actions .mgsessions-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 13px !important;
  }

  /* 1-column sessions grid */
  .mgsessions-grid,
  .sessions-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  .session-card,
  .mgsession-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgsession-card-top,
  .session-card-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .mgsession-badge-stack {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
  }

  .session-card-title {
    font-size: 15px !important;
  }

  .session-card-summary,
  .mgsession-summary {
    font-size: 12.5px !important;
    line-height: 1.5 !important;
    margin: 8px 0 !important;
  }

  .session-card-footer {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-top: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SessionsPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA,YAAY;EACZ;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;;IAEE,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,YAAY;EACZ;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,2BAA2B;EAC3B;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================================================\n   SessionsPage.responsive.css\n   Responsive Stylesheet for Clinical Sessions Timeline & Workspace\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgsessions-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgsessions-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgsessions-hero h1 {\n    font-size: clamp(28px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgsessions-hero-panel {\n    max-width: 100% !important;\n    padding: 20px !important;\n  }\n\n  .mgsessions-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 18px 0 !important;\n  }\n\n  /* Toolbar */\n  .mgsessions-toolbar {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .mgsessions-toolbar-filters {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n\n  .mgsessions-toolbar-actions {\n    display: flex !important;\n    gap: 10px !important;\n    width: 100% !important;\n    justify-content: flex-end !important;\n  }\n\n  .mgsessions-grid,\n  .sessions-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 14px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgsessions-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgsessions-hero {\n    padding: 16px 14px !important;\n    gap: 16px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgsessions-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgsessions-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgsessions-hero-actions {\n    display: flex !important;\n    gap: 8px !important;\n    width: 100% !important;\n  }\n\n  .mgsessions-hero-actions .mgsessions-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  .mgsessions-hero-panel {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgsessions-panel-top strong {\n    font-size: 15px !important;\n  }\n\n  .mgsessions-mini-chart {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin-top: 10px !important;\n  }\n\n  .mgsessions-mini-stat {\n    padding: 8px 10px !important;\n    border-radius: 10px !important;\n  }\n\n  .mgsessions-mini-stat strong {\n    font-size: 15px !important;\n  }\n\n  /* Stats Grid */\n  .mgsessions-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgsessions-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgsessions-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgsessions-stat-card span {\n    font-size: 10px !important;\n  }\n\n  .mgsessions-stat-card small {\n    display: none !important;\n  }\n\n  /* Toolbar */\n  .mgsessions-toolbar {\n    margin: 14px 0 !important;\n  }\n\n  .mgsessions-toolbar-filters {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n  }\n\n  .mgsessions-filter-input,\n  .mgsessions-filter-select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  .mgsessions-toolbar-actions {\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  .mgsessions-toolbar-actions .mgsessions-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 13px !important;\n  }\n\n  /* 1-column sessions grid */\n  .mgsessions-grid,\n  .sessions-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  .session-card,\n  .mgsession-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgsession-card-top,\n  .session-card-header {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n  }\n\n  .mgsession-badge-stack {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n  }\n\n  .session-card-title {\n    font-size: 15px !important;\n  }\n\n  .session-card-summary,\n  .mgsession-summary {\n    font-size: 12.5px !important;\n    line-height: 1.5 !important;\n    margin: 8px 0 !important;\n  }\n\n  .session-card-footer {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    margin-top: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
